if (![].at) {
  Array.prototype.at = function(pos) { return this.slice(pos, pos + 1)[0] }
}

import * as Sentry from "@sentry/vue"
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import { version } from '../package.json'
import App from './App.vue'
import router from './router'

// CSS
import './assets/classes.css'
// import './assets/main.css'

// Vuetify
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import 'vuetify/styles'

// Vue i18n
import i18n from './plugins/i18n'

// Vue 3 Touch Events
import Vue3TouchEvents from "vue3-touch-events"

const app = createApp(App)

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
})

if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'production',
    release: version,
    integrations: [],
    tracesSampleRate: 0,
    tracePropagationTargets: import.meta.env.VITE_SENTRY_TRACE_TARGETS?.split(','),
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,
    beforeSend(event, hint) {
      const error = hint?.originalException
      const isAxiosError = error?.name === 'AxiosError' || error?.isAxiosError === true
      if (isAxiosError && error?.message === 'Network Error') {
        return null
      }
      if (isAxiosError && (error?.response?.status === 0 || (!error?.response && error?.code === 'ERR_NETWORK'))) {
        return null
      }
      return event
    },
  });
}

app.use(createPinia())

// Initialize store watchers
import { useStore } from './stores/store'
const store = useStore()
store.initializeWatchers()

app.use(router)
app.use(vuetify)
app.use(i18n)
app.use(Vue3TouchEvents)
app.mount('#app')
